import {observable} from "@nx-js/observer-util";
import {WebsitePostType} from "../../models/website/posts/WebsitePostType";
import {INetworkComponent} from "../../network/types/INetworkComponent";
import {IWebsitePostIncoming} from "../../models/website/posts/IWebsitePostIncoming";
import {Network} from "../../network/Network";
import {ProductType} from "../../models/product/ProductType";
import {HttpStatus} from "../../network/status/HttpStatus";
import {IPaginationOutgoing} from "../../models/pagination/IPaginationOutgoing";
import {IWebsitePostsIncoming} from "../../models/website/posts/IWebsitePostsIncoming";
import {SedestralSsr} from "../../sedestral/framework/ssr/SedestralSsr";

export class WebsitePostsService {

    private static ssrGetPost: IWebsitePostIncoming = observable();
    private static ssrGetLastPosts: IWebsitePostsIncoming = observable();

    public static init(): void {
        window["WebsitePostsService"] = this;
    }

    public static async getPost(language: string, websitePostType: WebsitePostType, route: string, component?: INetworkComponent): Promise<IWebsitePostIncoming> {
        if (SedestralSsr.hasSsr() && this.ssrGetPost) {
            return Promise.resolve(this.ssrGetPost);
        }

        let request = await Network.get(ProductType.WEBSITE, `/website/posts/${language}/${websitePostType}/${route}`, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
    }

    public static async getLastPosts(language: string, websitePostType: WebsitePostType, paginationIncoming: IPaginationOutgoing, component?: INetworkComponent): Promise<IWebsitePostsIncoming> {
        if (SedestralSsr.hasSsr() && this.ssrGetLastPosts) {
            return Promise.resolve(this.ssrGetLastPosts);
        }

        let request = await Network.postJson(ProductType.WEBSITE, `/website/posts/${language}/${websitePostType}`, paginationIncoming, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
    }

    public static async refresh(component?: INetworkComponent): Promise<boolean> {
        let request = await Network.get(ProductType.WEBSITE, "/website/posts/refresh", component);
        if (request.status == HttpStatus.OK) {
            return true;
        }
    }

    /**
     * SSR
     */

    public static setContextSsr(context: string) {
        let object = JSON.parse(context);

        if (object.pagination) {
            this.ssrGetLastPosts = observable(object);
        } else {
            this.ssrGetPost = observable(object);
        }
    }
}